// 导出任务
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">

      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style=" height: calc(100vh - -35px);">
          <vxe-grid show-overflow :stripe="true" border="default" height="100%" :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-top" @click="openEditDialog"
                              v-if="barcodeSave">导出
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
                        @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="创建用户名称:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.userName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="文件名:" field="name">
                  <template v-slot>
                    <el-input v-model="formData.fileName" size="small" clearable/>
                  </template>
                </vxe-form-item>


              </vxe-form>
            </template>
            <!-- 分页器 -->
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {indexPageMixins} from "@/mixins/tabChang"
import {initVxeTable} from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi"
import {mapGetters} from "vuex";

export default {
  name: 'code',

  mixins: [indexPageMixins],
  components: {pager},
  data() {
    return {
      barcodeSave: false,
      barcodeEdit: false,
      showEdit: false,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
        userName: null,  // 创建用户名称
        fileName: null,  // 文件名称
      },
      formData: {
        userName: null,  // 创建用户名称
        fileName: null,  // 文件名称
      },

      total: 0,  // 数据总数
      vxeOption: {},
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '创建用户名称', field: 'userName', width: 150,},
        // {title: '执行SQL', field: 'exeSql', width: 200,},
        {
          title: '状态', field: 'stat', width: 150, slots: {
            default: ({row}) => {
              if (row.stat == 0) {
                return [
                  <div class="txt-status ">
                    <span>待执行</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>导出中</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status disable">
                    <span>导出失败</span>
                  </div>
                ];
              } else if (row.stat == 3) {
                return [
                  <div class="txt-status">
                    <span>待下载</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status">
                    <span>已下载</span>
                  </div>
                ];
              } else if (row.stat == 9) {
                return [
                  <div class="txt-status disable">
                    <span>执行失败</span>
                  </div>
                ];
              } else if (row.stat == 10) {
                return [
                  <div class="txt-status disable">
                    <span>中断</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消下载</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '文件名', field: 'fileName', width: 120,},
        {title: '文件大小(M)', field: 'fileSize', width: 120,},

        {title: '文件地址', field: 'fileUrl', width: 120,},
        {title: '文件生成时间', field: 'fileCreateTime', width: 150,},

        {
          title: '文件清除', field: 'fileClearStatus', width: 150, slots: {
            default: ({row}) => {
              if (row.fileClearStatus == 0) {
                return [
                  <div class="txt-status disable">
                    <span>未清除</span>
                  </div>
                ];
              } else if (row.fileClearStatus == 1) {
                return [
                  <div class="txt-status">
                    <span>已清除</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '文件清除时间', field: 'fileClearTime', width: 150,},
        {
          width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              if (row.fileUrl && row.stat != 99) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.doDownload(row);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="下载" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>

                  </div>
                ];
              } else if (row.stat === 1) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.stopStat(row);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="中断" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-close"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        },
        {
          width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              if (row.stat === 3) {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.cancelDownload(row);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="取消下载" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-circle-close"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        }
      ],
    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.barcodeSave = this.permissions['parts_barcode_add']
    this.barcodeEdit = this.permissions['parts_barcode_edit']
  },
  methods: {
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.intfDownload.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    //中止导出进程状态
    stopStat(row) {

      this.$baseConfirm('您确定要中断导出任务吗？').then(() => {
        this.updateStat(row, 10)
      })

    },

    // 更改导出状态
    updateStat(row, stat) {
      this.$http({
        url: api.intfDownload.updateStatUrl,
        method: `post`,
        data: {id: row.id, stat: stat}
      }).then(res => {
        this.$message.success("中断成功！")
        this.flushed()
      }).catch(e => {

      })
    },


    // 下载
    doDownload(row) {
      this.$baseConfirm('您确定要下载吗？').then(() => {
        this.$http({
          url: api.intfDownload.updateUrl,
          method: `post`,
          data: {id: row.id}
        }).then(res => {
          if (res.data.type == 'success') {
            //   let url = window.URL.createObjectURL(new Blob([res.data]))
            //   // 生成一个a标签
            //   let link = document.createElement('a')
            //   link.style.display = 'none'
            //   link.href = row.fileUrl
            //   // 生成时间戳
            //   let timestamp = new Date().getTime()
            //   link.download = row.fileName
            //   link.setAttribute('download', row.fileName);
            //   document.body.appendChild(link)
            //   link.click()
            //   link.remove()
            // }

            // this.$http.get(row.fileUrl, {
            //   responseType: 'blob',
            //   withCredentials: false,
            // }).then((e) => {
            //   console.log(e)
            //   const href = URL.createObjectURL(e.data)
            //   const aLink = document.createElement('a')
            //   aLink.style.display = 'none'
            //   aLink.href = href
            //   aLink.download = row.fileName
            //   aLink.click()
            //   URL.revokeObjectURL(row.fileUrl)
            // })
            // const link = document.createElement('a');
            // link.style.display = 'none';
            // // 设置下载地址
            // link.setAttribute('href',  row.fileUrl);
            // // 设置文件名
            // link.setAttribute('download', row.fileName);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            const x = new XMLHttpRequest()
            x.open("GET", row.fileUrl, true)
            x.responseType = 'blob'
            x.onload = function(e) {
              const url = window.URL.createObjectURL(x.response)
              const a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              a.download = row.fileName
              a.click()
              a.remove()
            }
            x.send()
          }



          this.$message({
            type: res.data.type,
            message: res.data.content
          });
          this.flushed()
        }).catch(e => {

        })

      })
    },
    cancelDownload(row) {
      this.$baseConfirm('您确定要取消下载？').then(() => {
        this.$http({
          url: api.cancelDownload.cancelDownload,
          method: `post`,
          data: {id: row.id}
        }).then(res => {
          if (res.data.type == 'success') {
            this.$message({
              type: res.data.type,
              message: "取消" + res.data.content
            });
          }
          this.flushed()
        }).catch(e => {

        })
      })
    }
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
